import {
  MaritalListActionTypes,
  MARITAL_STATUS_FAIL,
  MARITAL_STATUS_LOADING,
  MARITAL_STATUS_SUCCESS,
  MaritalListState,
  MARITAL_STATUS_API_MSG,
  MARITAL_STATUS_API_RES,
} from "./ActionTypes";
import { MaritalStatusResponse } from "./Model";

const initialStateEditPosts: MaritalListState = {
  loading: false,
  maritalStatusResponse: {} as MaritalStatusResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const maritalListReducer = (
  state = initialStateEditPosts,
  action: MaritalListActionTypes
): MaritalListState => {
  switch (action.type) {
    case MARITAL_STATUS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case MARITAL_STATUS_SUCCESS:
      return {
        ...state,
        maritalStatusResponse: action.payload,
        successMsg: action.successMsg,
      };
    case MARITAL_STATUS_FAIL:
      return {
        ...state,
        maritalStatusResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case MARITAL_STATUS_API_MSG:
      return {
        ...state,
        maritalStatusResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case MARITAL_STATUS_API_RES:
      return {
        ...state,
        maritalStatusResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
